export const TASKS_BASE_PATH = '/tasks';
